var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Toast from "@ingka/toast";
import "@ingka/toast/dist/style.css";
import { t } from "@preppa/translation";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            _this.setState({ hasError: false, errorMessage: "" });
        };
        _this.state = { hasError: false, errorMessage: "" };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return {
            hasError: true,
            errorMessage: error.message || t("common.errors.unexpectedError"),
        };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error("ErrorBoundary caught:", error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        return (_jsxs(_Fragment, { children: [this.props.children, _jsx(Toast, { isOpen: this.state.hasError, text: "".concat(t("common.errors.somethingWentWrong"), ": ").concat(this.state.errorMessage), onCloseRequest: this.handleClose, ariaLabelCloseBtn: t("common.errors.dismissError") })] }));
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
